module.exports = __webpack_public_path__ + "7d6e2f52636742052d7f68c4d0cafa57.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/folder_lock_icon.png
// module id = 88
// module chunks = 0 1 2 3 4